import React, { useEffect, useState } from 'react';
import { Card, Typography, Button, Alert, Spin } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';

const { Title, Text, Paragraph } = Typography;

function QuotesDebug() {
    const { user } = useAuth();
    const [loading, setLoading] = useState(false);
    const [debugInfo, setDebugInfo] = useState(null);
    const [error, setError] = useState(null);

    const runDebug = async () => {
        setLoading(true);
        setError(null);
        
        try {
            const debugData = {
                currentUser: user,
                timestamp: new Date().toISOString()
            };

            // Test quotes API
            try {
                const quotesResponse = await api.getQuotes();
                debugData.quotesApi = {
                    success: true,
                    response: quotesResponse,
                    dataCount: quotesResponse?.data?.data?.length || quotesResponse?.data?.length || 0
                };
            } catch (quotesError) {
                debugData.quotesApi = {
                    success: false,
                    error: quotesError.message,
                    response: quotesError.response?.data
                };
            }

            // Test alternative API call
            try {
                const altResponse = await api.get('/quotes');
                debugData.alternativeApi = {
                    success: true,
                    response: altResponse,
                    dataCount: altResponse?.data?.data?.length || altResponse?.data?.length || 0
                };
            } catch (altError) {
                debugData.alternativeApi = {
                    success: false,
                    error: altError.message,
                    response: altError.response?.data
                };
            }

            setDebugInfo(debugData);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        runDebug();
    }, []);

    if (loading) {
        return <Spin size="large" />;
    }

    return (
        <div className="max-w-4xl mx-auto p-6">
            <Title level={2}>Quotes Debug Information</Title>
            
            {error && (
                <Alert
                    message="Error"
                    description={error}
                    type="error"
                    className="mb-4"
                />
            )}

            <Card title="Current User" className="mb-4">
                <pre>{JSON.stringify(user, null, 2)}</pre>
            </Card>

            {debugInfo && (
                <>
                    <Card title="Quotes API (getQuotes)" className="mb-4">
                        <Paragraph>
                            <Text strong>Success:</Text> {debugInfo.quotesApi.success ? 'Yes' : 'No'}
                        </Paragraph>
                        {debugInfo.quotesApi.success ? (
                            <Paragraph>
                                <Text strong>Data Count:</Text> {debugInfo.quotesApi.dataCount}
                            </Paragraph>
                        ) : (
                            <Paragraph>
                                <Text strong>Error:</Text> {debugInfo.quotesApi.error}
                            </Paragraph>
                        )}
                        <pre>{JSON.stringify(debugInfo.quotesApi.response, null, 2)}</pre>
                    </Card>

                    <Card title="Alternative API (get('/quotes'))" className="mb-4">
                        <Paragraph>
                            <Text strong>Success:</Text> {debugInfo.alternativeApi.success ? 'Yes' : 'No'}
                        </Paragraph>
                        {debugInfo.alternativeApi.success ? (
                            <Paragraph>
                                <Text strong>Data Count:</Text> {debugInfo.alternativeApi.dataCount}
                            </Paragraph>
                        ) : (
                            <Paragraph>
                                <Text strong>Error:</Text> {debugInfo.alternativeApi.error}
                            </Paragraph>
                        )}
                        <pre>{JSON.stringify(debugInfo.alternativeApi.response, null, 2)}</pre>
                    </Card>
                </>
            )}

            <Button type="primary" onClick={runDebug} loading={loading}>
                Refresh Debug Info
            </Button>
        </div>
    );
}

export default QuotesDebug;
